import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'

const STORAGE_KEY = 'calendly_booking_product_refresh_preview'

const noop = () => {}

const defaultContextValue = {
  override: true,
  setOverride: noop,
}

const AppLayoutOverrideContext = createContext(defaultContextValue)

const readFromStorage = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'true') return true
    if (stored === 'false') return false
  } catch {
    // localStorage may be unavailable in strict browsing modes.
  }

  return true
}

export const AppLayoutOverrideProvider = ({ children }) => {
  const [override, setOverrideState] = useState(readFromStorage)

  const setOverride = useCallback((value) => {
    try {
      localStorage.setItem(STORAGE_KEY, String(value))
    } catch {
      // Ignore write failures; the in-memory preview still works.
    }

    setOverrideState(value)
  }, [])

  useEffect(() => {
    const handler = (event) => {
      if (event.key !== STORAGE_KEY) return

      const value = event.newValue
      if (value === 'true') setOverrideState(true)
      else if (value === 'false') setOverrideState(false)
      else setOverrideState(true)
    }

    window.addEventListener('storage', handler)
    return () => window.removeEventListener('storage', handler)
  }, [])

  const value = useMemo(
    () => ({ override, setOverride }),
    [override, setOverride]
  )

  return (
    <AppLayoutOverrideContext.Provider value={value}>
      {children}
    </AppLayoutOverrideContext.Provider>
  )
}

export const useProductRefreshPreviewContext = () => (
  useContext(AppLayoutOverrideContext)
)
